function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M5.758.02a5.74 5.74 0 014.613 9.168l3.103 2.625a1.186 1.186 0 11-1.672 1.672l-2.626-3.103A5.746 5.746 0 115.758.021zm0 10.287A4.538 4.538 0 101.22 5.769a4.538 4.538 0 004.538 4.538z"
});

var SvgSearchIcon = function SvgSearchIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};

export default SvgSearchIcon;